import { render } from "./SupportForm.vue?vue&type=template&id=874cae12&scoped=true&ts=true"
import script from "./SupportForm.ts?vue&type=script&lang=ts"
export * from "./SupportForm.ts?vue&type=script&lang=ts"

import "./SupportForm.scss?vue&type=style&index=0&id=874cae12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874cae12"]])

export default __exports__